/* global process */

import React, { PureComponent, useState } from 'react';

import './stylesheet.css';

import DropboxLogo from 'url:./dropbox.svg';
import GitLabLogo from 'url:./gitlab.svg';

import { persistField } from '../../util/settings_persister';
import {
  directSignInLink,
  signInToGitLabProject,
  DEFAULT_POST_SIGN_IN_PATH,
} from '../../lib/gitlab_direct_sign_in';
import gitlabOrgProjects from '../../lib/gitlab_org_projects.json';

import { DropboxAuth } from 'dropbox';
import _ from 'lodash';

function WebDAVForm() {
  const [isVisible, setIsVisible] = useState(false);
  const toggleVisible = () => setIsVisible(!isVisible);
  const [url, setUrl] = useState(process.env.REACT_APP_WEBDAV_URL);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  return (
    <div id="webdavLogin">
      <h2>
        <a href="#webdav" onClick={toggleVisible} style={{ textDecoration: 'none' }}>
          WebDAV
        </a>
      </h2>
      {isVisible && (
        <>
          <form
            onSubmit={(event) => {
              event.preventDefault();
              persistField('authenticatedSyncService', 'WebDAV');
              persistField('webdavEndpoint', url);
              persistField('webdavUsername', username);
              persistField('webdavPassword', password);
              window.location = window.location.origin + '/';
            }}
          >
            <p>
              <label htmlFor="input-webdav-url">URL:</label>
              <input
                id="input-webdav-url"
                name="url"
                type="url"
                value={url}
                className="textfield"
                onChange={(e) => {
                  setUrl(e.target.value);
                }}
              />
            </p>
            <p>
              <label htmlFor="input-webdav-user">Username:</label>
              <input
                id="input-webdav-user"
                type="text"
                className="textfield"
                value={username}
                onChange={(e) => {
                  setUsername(e.target.value);
                }}
              />
            </p>
            <p>
              <label htmlFor="input-webdav-password">Password:</label>
              <input
                id="input-webdav-password"
                type="password"
                className="textfield"
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                }}
              />
            </p>
            <input type="submit" value="Sign-in" />
          </form>
          <p>
            Please make sure your WebDAV backend meets the requirements as documented{' '}
            <a
              href="https://organice.200ok.ch/documentation.html#faq_webdav"
              target="_blank"
              rel="noopener noreferrer"
            >
              here
            </a>
            , especially{' '}
            <a
              href="https://organice.200ok.ch/documentation.html#webdav_cors"
              target="_blank"
              rel="noopener noreferrer"
            >
              CORS
            </a>
            .
          </p>
        </>
      )}
    </div>
  );
}

// Fixed at build time; regenerated by CI (bin/update_gitlab_org_projects.js)
// rather than queried from GitLab when the sign-in page loads.
const ORG_PROJECTS = gitlabOrgProjects;

function GitLab() {
  const [isVisible, setIsVisible] = useState(false);
  const toggleVisible = () => setIsVisible(!isVisible);
  const [isOrgMenuVisible, setIsOrgMenuVisible] = useState(false);

  const [project, setProject] = useState('');
  const handleSubmit = (evt) => {
    evt.preventDefault();
    signInToGitLabProject(project);
  };

  return (
    <>
      <a href="#gitlab" onClick={toggleVisible}>
        <img src={GitLabLogo} alt="GitLab logo" />
      </a>
      {isVisible && (
        <>
          <div className="gitlab-project-buttons">
            <button
              type="button"
              className="btn"
              onClick={() => signInToGitLabProject('https://www.fireweaver.org/org/ml')}
            >
              M&amp;L
            </button>
            <button
              type="button"
              className="btn"
              onClick={() => signInToGitLabProject('https://www.fireweaver.org/org/org')}
            >
              M
            </button>
            <button
              type="button"
              className="btn"
              aria-expanded={isOrgMenuVisible}
              onClick={() => setIsOrgMenuVisible(!isOrgMenuVisible)}
            >
              org/*
            </button>
          </div>
          {isOrgMenuVisible && (
            <p>
              <select
                aria-label="Repository under www.fireweaver.org/org/"
                className="gitlab-org-project-select"
                defaultValue=""
                onChange={(e) => e.target.value && signInToGitLabProject(e.target.value)}
              >
                <option value="" disabled>
                  Select a repository…
                </option>
                {ORG_PROJECTS.map(({ path, url }) => (
                  <option key={path} value={url}>
                    {path}
                  </option>
                ))}
              </select>
            </p>
          )}
          <p className="gitlab-direct-links">
            Direct links (sign in and open <code>{DEFAULT_POST_SIGN_IN_PATH}</code>):{' '}
            <a href={directSignInLink('org/ml')}>M&amp;L</a> ·{' '}
            <a href={directSignInLink('org/org')}>M</a>
          </p>
          <form onSubmit={handleSubmit}>
            <p>
              <label htmlFor="input-gitlab-project">Project:</label>
              <input
                id="input-gitlab-project"
                type="url"
                className="textfield"
                value={project}
                onChange={(e) => setProject(e.target.value)}
              />
            </p>
            <input type="submit" value="Sign-in" />
          </form>
        </>
      )}
    </>
  );
}

export default class SyncServiceSignIn extends PureComponent {
  constructor(props) {
    super(props);

    _.bindAll(this, ['handleDropboxClick']);
  }

  handleDropboxClick() {
    persistField('authenticatedSyncService', 'Dropbox');
    const REDIRECT_URI = window.location.origin + '/';

    const dbxAuth = new DropboxAuth({
      clientId: process.env.REACT_APP_DROPBOX_CLIENT_ID,
      fetch: fetch.bind(window),
    });

    dbxAuth
      .getAuthenticationUrl(REDIRECT_URI, undefined, 'code', 'offline', undefined, undefined, true)
      .then((authUrl) => {
        persistField('codeVerifier', dbxAuth.codeVerifier);
        window.location.href = authUrl;
      })
      .catch((error) => console.error(error));
  }

  render() {
    return (
      <div className="sync-service-sign-in-container">
        <p className="sync-service-sign-in__help-text">
          organice syncs your files with Dropbox, GitLab, and WebDAV.
        </p>
        <p className="sync-service-sign-in__help-text">Click to sign in with:</p>

        <div className="sync-service-container">
          <a href="#dropbox" onClick={this.handleDropboxClick}>
            <img src={DropboxLogo} alt="Dropbox logo" className="dropbox-logo" />
          </a>
        </div>

        <div className="sync-service-container">
          <GitLab />
        </div>

        <div className="sync-service-container">
          <WebDAVForm />
        </div>

        <footer>
          For questions regarding synchronization back-ends, please consult the{' '}
          <a
            href="https://organice.200ok.ch/documentation.html#sync_backends"
            target="_blank"
            rel="noopener noreferrer"
          >
            documentation
          </a>
          .
        </footer>
      </div>
    );
  }
}
